import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_8m9j47nd48: FaireBrandEntity = {
  token: "b_8m9j47nd48",
  type: "brand",
  name: "Candle Bliss",
  avatarUrl:
    "https://cdn.faire.com/fastly/32d8935e67780ecb50042cb515cb1571bdd425cada0b66694a557af8e33f9bab.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/7d801d1782d66079e3db4348467fe476661d4474c437b53436eba6649538a490.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/32d8935e67780ecb50042cb515cb1571bdd425cada0b66694a557af8e33f9bab.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/7d801d1782d66079e3db4348467fe476661d4474c437b53436eba6649538a490.jpeg",
  location: "Phoenix, AZ, USA",
  minimumOrderDollars: 150,
  rating: 5,
  reviewCount: 53,
  isTopShop: true,
  isInsider: true,
  description:
    "Candle Bliss —where passion meets fragrance and creativity ignites every room! At Candle Bliss, we’re redefining the art of candle making, offering a unique blend of premium, handcrafted scents, and custom designs delivered straight to your doorstep. \n\nAs a premier print-on-demand and dropshipping candle company, we make it effortless for you to infuse your space with warmth and personality. Whether you're seeking the perfect products to add to your store or a signature candle for your brand, Candle Bliss offers endless possibilities to spark unlimited possibilities. Welcome to a world where every candle tells a story— your story.\n\nCandleBliss.com",
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:51:09.082Z",
    importedBy: "entity-db-cli",
  },
};
